import FieldsetContainer from '@/components/shared/FieldsetContainer';

import CourseForm, {
  CourseFormFields,
} from './CourseForm';

type PedContentInlineFormProps = {
  onSubmit: (data: CourseFormFields) => Promise<unknown>;
  onCancel: () => void;
  isLoading?: boolean;
};

export default function PedContentInlineForm({
  onSubmit,
  onCancel,
  isLoading,
}: PedContentInlineFormProps) {
  return (
    <FieldsetContainer>
      <CourseForm
        onSubmit={onSubmit}
        onCancel={onCancel}
        isLoading={isLoading}
        variant="inline"
      />
    </FieldsetContainer>
  );
}
